var quizOpen = false;
var quizCount = 0;

function quizShow() {
  document.getElementById('quiz-wrapper').style.display = "block";
  document.getElementById('quiz-wrapper').style.position = "fixed";
  document.getElementById('quiz-wrapper').style.zIndex = "9999999";
  document.getElementById('quiz-wrapper').style.overflow = "auto";
  document.getElementById('quiz-wrapper').style.height = "100%";
  //$('.answers').css("padding-bottom","100%");
  //$('.freegift_answers').css("padding-bottom","100%");
  $('#question_email').css("padding-bottom","100%");
  $('.next_button_background').css("z-index","999999");
  $('.bottombar-wrapper').css("position","absolute");
  $('body').css("overflow","hidden");
  $('body').css("position","fixed");
  if (quizCount == 0){
    startTimerQ();
    ga('send', 'event', 'Quiz', 'Start Quiz', 'SweatQuiz0');
    window._conv_q = window._conv_q || [];
	_conv_q.push(["triggerConversion", "100317771"]);
  }
  quizCount = 1;

  //Run session storage memory function here to get old answers
  var quizAnswers = JSON.parse(sessionStorage.getItem('answers'));
  if(quizAnswers){
    for (i=0; i<quizAnswers.length;i++){
      document.getElementById(quizAnswers[i]).classList.toggle('answer_selected');
      document.getElementById(quizAnswers[i]).parentElement.nextElementSibling.children[0].disabled = false;
    }
    //replaces free gift in timer box if you're on a different question
    if (quizAnswers[0] == 'choice_freeexfoliator'){
      document.getElementById('timer_image').src = "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/freegift_exfoliator.jpg?v=1631559286";
    } else if (quizAnswers[0] == 'choice_freemini'){
      document.getElementById('timer_image').src = "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/2wipessmall.png?v=1657153864";
    } else if (quizAnswers[0] == 'choice_freebag') {
      document.getElementById('timer_image').src = "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/bag.jpg?v=1658779317";
    } else {
      document.getElementById('timer_image').src = "https://cdn.shopify.com/s/files/1/0335/1622/4645/t/111/assets/freegift_default_200x.png?v=6815870730005612561";
    }
  }



  //Sets back to current question
  var currentQ = sessionStorage.getItem('currentQ');
  if (currentQ) {
    if (currentQ != 'question_freegift') {
      document.getElementById('question_freegift').classList.add('inactive');
      document.getElementById(currentQ).classList.remove('inactive');
    }
  } else {
    sessionStorage.setItem('currentQ','question_freegift')
  }
  addFutureQuestions();
  setTimeout(function(){
    quizOpen = true;
    return quizOpen;
  },100)
	window.scrollTo(0,0);
}

function quizHide() {
  $('.quiz-wrapper').css("display","none");
  $('body').css("position","");
  $('body').css("overflow","auto");
  $('.bottombar-wrapper').css("position","sticky");
  sessionStorage.setItem('currentQ','');
  quizOpen = false;
  return quizOpen;
}



//Function to hide cart upsell after it's clicked
var isCrossSellOpen = true;
function hideCrossSell() {
  isCrossSellOpen = false;
}
$(document).ready(function() {
  cartUpsell();
});

const targetNode = document.getElementById('offcanvas-cart-drawer');
const observerOptions = {
  childList: true,
  attributes: true,
  // Omit (or set to false) to observe only changes to the parent node
  subtree: false
}

const observer = new MutationObserver(callback);
observer.observe(targetNode, observerOptions);

function callback(mutationList, observer) {
  mutationList.forEach( (mutation) => {
    switch(mutation.type) {
      case 'childList':
        cartUpsell();
         $('li.39709236887685').insertAfter($('li.CartDrawerItem').last());
        break;
      case 'attributes':
        cartUpsell();
         $('li.39709236887685').insertAfter($('li.CartDrawerItem').last());
        break;
    }
  });
}

//Add to cart button for cart upsell
function crossSellATC(){
    var quantity = 1
    var id = document.getElementById('ATCInput').value
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {id:id,quantity:quantity},
        success: function(){
          fetch('/?section_id=cart-drawer')
          .then(response => response.text())
          .then(data => document.getElementById('offcanvas-cart-drawer').innerHTML = data);
        }
    });
  };


//Loads to function for cart upsell recommendation
const open = window.XMLHttpRequest.prototype.open;

function openReplacement() {
  this.addEventListener("load", function () {
    if (
      [
        "/cart/add.js"
      ].includes(this._url)
    ) {
      cartExfoliator(this.response);
    }
  });
  return open.apply(this, arguments);
}

window.XMLHttpRequest.prototype.open = openReplacement;

function cartExfoliator(cartJson) {
  var item = JSON.parse(cartJson);
  if (item.quantity == 1 && item.id != 39709236887685) {
    ttq.track('AddToCart', {
      content_type: 'product',
      content_id: item.sku
    });
	  //snaptr('track', 'ADD_CART');
     pintrk('track', 'addtocart', {currency: 'USD'});
    //Convert ATC
    window._conv_q = window._conv_q || [];
    _conv_q.push(["triggerConversion", "100321605"]);
  }
  if (item.variant_title == 'Original'){
    window._conv_q = window._conv_q || [];
	_conv_q.push(["triggerConversion", "100320288"]);
  } else if (item.variant_title == 'Fragrance Free' || item.variant_title == 'Fresh Powder' || item.variant_title == 'Mountain Breeze' || item.variant_title == 'Cucumber Splash'  ) {
    window._conv_q = window._conv_q || [];
    _conv_q.push(["triggerConversion", "100320289"]);
  } else if (item.variant_title == 'Apple Spice'){
    window._conv_q = window._conv_q || [];
    _conv_q.push(["triggerConversion", "100321471"]);
  }
  
  if (item.variant_title == 'Fragrance Free') {
    //console.log('FF');
    window._conv_q = window._conv_q || [];
    _conv_q.push(["triggerConversion", "100320290"]);
  }
  //this auto changes holiday one pack to the 3 pack 
  if (item.variant_id == 40007449510021) {
      cartUpdates = {
        'updates': {
          40007449510021: 0,
          40007449870469: 1
        }
      };
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: cartUpdates,
        dataType: 'json',
        success: function() {
          fetch('/?section_id=cart-drawer')
          .then(response => response.text())
          .then(data => document.getElementById('offcanvas-cart-drawer').innerHTML = data);
        }
      });
  }
  //This code adds the exfoliator to cart (GWP)
  /*if (item.product_id == 5115172159621 || item.product_id == 6657190199429 || item.product_id == 5110023749765 || item.product_id == 5115170979973 || item.product_id == 5110006022277 || item.product_id == 5110018932869 || item.product_id == 6591209963653 || item.product_id == 6607242559621 || item.product_id == 6607242526853 || item.product_id == 6648686248069 || item.product_id == 6657195671685 || item.product_id == 6648666095749 || item.product_id == 6648688115845 || item.product_id == 6648687624325) {
    cartUpdates = {
      "id": 39709236887685,
      "quantity": 1,
    };
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: cartUpdates,
      dataType: 'json',
      success: function() {
        fetch('/?section_id=cart-drawer')
          .then(response => response.text())
          .then(data => document.getElementById('offcanvas-cart-drawer').innerHTML = data);
      }
    });
  }*/
}


$(document).ready(function() {
  if($('.ProductRadioButtons-itemLabel.Fresh.Linen')[0]){
  	//$('.ProductForm-variant-title.Fresh.Linen').replaceWith('<div class="ProductForm-variant-title Fresh" style="line-height:18px;">Fresh Linen<br/><span style="color:#DF0334">Out Of Stock</span></div>');
  	//document.getElementsByClassName('ProductRadioButtons-itemLabel Fresh')[0].previousElementSibling.disabled = true;
  }
  if($('.ProductRadioButtons-itemLabel.Original')[0]){
  		$('.ProductForm-variant-title.Original').replaceWith('<div class="ProductForm-variant-title Original">Eucalyptus</div>');
		//$('.ProductForm-variant-title.Original').css("line-height", "14px");
  }
  if($('.ProductRadioButtons-itemLabel.Fresh.Cotton')[0]){
    $('.ProductForm-variant-title.Original').replaceWith('<div class="ProductForm-variant-title Original" style="line-height:14px;">Original<br/><span style="color:#DF0334">Out Of Stock</span></div>');
    document.getElementsByClassName('ProductRadioButtons-itemLabel Original')[0].previousElementSibling.disabled = true;
  }
   if($('.ProductRadioButtons-itemLabel.Fresh')[0]){
    $('.ProductForm-variant-title.Fresh.Powder').replaceWith('<div class="ProductForm-variant-title Fresh">Fresh<br/>Powder<br/><span style="line-height:14px;">(FAVORITE)</span></div>');
  }
  if($('.ProductRadioButtons-itemLabel.Cucumber')[0]){
    $('.ProductForm-variant-title.Cucumber').replaceWith('<div class="ProductForm-variant-title Cucumber">Cucumber<br/>Splash</div>');
    /*$('.ProductForm-variant-title.Cucumber').replaceWith('<div class="ProductForm-variant-title Cucumber">Cucumber<br/>Splash<br/><span style="color:#DF0334">Out Of Stock</span></div>');
    document.getElementsByClassName('ProductRadioButtons-itemLabel Cucumber')[0].previousElementSibling.disabled = true;*/
  }
  if($('.ProductRadioButtons-itemLabel.Mountain')[0]){
    $('.ProductForm-variant-title.Mountain').replaceWith('<div class="ProductForm-variant-title Mountain">Mountain<br/>Breeze</div>');
  }
  if($('.ProductRadioButtons-itemLabel.Fragrance')[0]){
    if(fragranceFreeName === true){ //fragrance free vs. unscented test 
      $('.ProductForm-variant-title.Fragrance').replaceWith('<div class="ProductForm-variant-title Fragrance">Unscented</div>');
    } else {
      $('.ProductForm-variant-title.Fragrance').replaceWith('<div class="ProductForm-variant-title Fragrance">Fragrance<br/>Free</div>');
    }
    $('.ProductForm-variant-title.Fragrance').css("color","#1095D0");
  }
  if($('.ProductRadioButtons-itemLabel.Rose')[0]){
    //document.getElementsByClassName('ProductRadioButtons-item')[2].style.display = "none";
    //document.getElementsByClassName('ProductRadioButtons-item')[3].style.display = "none";
    //document.getElementsByClassName('ProductRadioButtons-item')[4].style.display = "none";
    //document.getElementsByClassName('ProductRadioButtons-item')[5].style.display = "none"; 
    //document.getElementsByClassName('ProductRadioButtons-item')[7].style.display = "none"; 
    document.getElementsByClassName('ProductRadioButtons-item')[8].style.display = "none"; 
    document.getElementsByClassName('ProductRadioButtons-item')[9].style.display = "none"; 
    document.getElementsByClassName('ProductRadioButtons-item')[10].style.display = "none"; 
    document.getElementsByClassName('ProductRadioButtons-item')[11].style.display = "none"; 
    document.getElementsByClassName('ProductRadioButtons-item')[12].style.display = "none"; 
    document.getElementsByClassName('ProductRadioButtons-item')[13].style.display = "none"; 
    
   }



if($('.ProductRadioButtons-itemLabel.Holiday')[0]){

   var parentBlock = document.getElementsByClassName('ProductRadioButtons-group')[0].parentNode;
   var childBlock = document.getElementsByClassName('ProductRadioButtons-group')[0];
   var newApple = document.createElement("div");
    newApple.innerHTML = '<div class="ProductRadioButtons-group" style="position:relative; background:white; z-index:2;" ><div class="ProductRadioButtons-groupTitle">Limited Edition Scents</div><div class="ProductRadioButtons-groupwrapper"><div class="limitedScentItem"><input id="product-6591209963653-option-0-10" class="js-product-option ProductRadioButtons-itemRadio" type="radio" name="product-6591209963653-option-0" value="Holiday Bundle" data-index="10" data-group-index="0"><label for="product-6591209963653-option-0-10" class="ProductRadioButtons-itemLabel Holiday Bundle"><div sel-val="Holiday Bundle" class="ProductRadioButtons-itemLabel-value Holiday Bundle limitedScentLabel"></div></label><div class="ProductForm-variant-title Holiday Bundle">Holiday Bundle</div></div></div></div>';
   
   
   var variantFix = 0;
   

   //THIS INSERTS AFTER
     Element.prototype.appendAfter = function (element) {
      element.parentNode.insertBefore(this, element.nextSibling);
     },false;
     newApple.appendAfter(childBlock)


     //moves scent profile above limited scents 
     if(document.getElementsByClassName('scentProfile')[0]){
       var scentProfileNode = document.getElementsByClassName('scentProfile')[0]
       scentProfileNode.appendAfter(childBlock)
       scentProfileNode.style.marginBottom = "20px"
    }

     document.getElementsByClassName('ProductRadioButtons-groupTitle')[0].innerHTML = "CLASSIC SCENTS"

    //SIMULATE APPLE CLICK TO CHANGE BACKEND PRODUCT
    const limitedScents = document.getElementsByClassName('limitedScentItem');
    Array.from(limitedScents).forEach(limitedScent => {
      limitedScent.addEventListener('click', function(event) {
        var thisItem = event.target;
        //console.log(thisItem);
        var findIndex = thisItem.dataset.index;
        //console.log(findIndex);
        document.getElementsByClassName('ProductRadioButtons-item')[findIndex].click();
        document.getElementsByClassName('ProductRadioButtons-item')[findIndex].childNodes[0].click();
        document.getElementsByClassName('ProductRadioButtons-item')[findIndex].childNodes[1].click();
        document.getElementsByClassName('ProductRadioButtons-item')[findIndex].childNodes[2].click();
        document.getElementsByClassName('limitedScentLabel')[0].style.opacity = "1";
        //Auto clicks 3 packs and disables other quant options
        clickOnHoliday();

      });
    });

    // THIS UNCHECKS THE FAUX APPLE SPICE SELECTOR WHEN ANOTHER SCENT IS SELECTED
    const otherProductScents = document.getElementsByClassName('ProductRadioButtons-item');
    Array.from(otherProductScents).forEach(otherProductScent => {
      otherProductScent.addEventListener('click', function(event) {
          //console.log(event.target)
          var limitedScentTempIndex = event.target.dataset.index;
          var limitedScentSKU = carpe_products['CP-UA'].variants[limitedScentTempIndex].sku;
          //console.log(limitedScentSKU)
          if (limitedScentSKU != "CP-UA-SA") {
            document.getElementsByClassName('limitedScentLabel')[0].style.opacity = "0";
            clickOffHoliday();
          }
        
      });
    });

    //Auto Clicks 3 pack & disables other quant options
    function clickOnHoliday() {
      document.getElementsByClassName('quant_block__type__three')[0].click();
      //changes bg color
      document.getElementsByClassName('quant_block__type')[0].style.backgroundColor = "#ccc"
      document.getElementsByClassName('quant_block__type')[1].style.backgroundColor = "#ccc" 
      document.getElementsByClassName('quant_block__type')[3].style.backgroundColor = "#ccc" 
      //disables clicks
      document.getElementsByClassName('quant_block__type')[0].style.pointerEvents = "none"
      document.getElementsByClassName('quant_block__type')[1].style.pointerEvents = "none"
      document.getElementsByClassName('quant_block__type')[3].style.pointerEvents = "none"
      //changes scent profile
      document.getElementsByClassName('scentProfile')[0].innerHTML = "<span style='color: #444'>Holiday Bundle:</span> <b>Warm Gingerbread,<br/>Peppermint Bark, Christmas Tree</b>"
    }

    function clickOffHoliday() {
      //changes bg color
      document.getElementsByClassName('quant_block__type')[0].style.backgroundColor = "#fff"
      document.getElementsByClassName('quant_block__type')[1].style.backgroundColor = "#fff" 
      document.getElementsByClassName('quant_block__type')[3].style.backgroundColor = "#fff" 
      //disables clicks
      document.getElementsByClassName('quant_block__type')[0].style.pointerEvents = "auto"
      document.getElementsByClassName('quant_block__type')[1].style.pointerEvents = "auto"
      document.getElementsByClassName('quant_block__type')[3].style.pointerEvents = "auto"
    }


   
   $('.ProductRadioButtons-itemLabel.Holiday').css("margin-left","35px");
   $('.ProductForm-variant-title.Holiday').css("text-align","left");
   $('.ProductForm-variant-title.Holiday').css("margin-left","10px");
};







  /*Apple Spice Limited Edition
if($('.ProductRadioButtons-itemLabel.Sweet')[0]){

   var parentBlock = document.getElementsByClassName('ProductRadioButtons-group')[0].parentNode;
   var childBlock = document.getElementsByClassName('ProductRadioButtons-group')[0];
   var newApple = document.createElement("div");
    newApple.innerHTML = '<div class="ProductRadioButtons-group"><div class="ProductRadioButtons-groupTitle">Limited Edition Scents</div><div class="ProductRadioButtons-groupwrapper"><div class="limitedScentItem"><input id="product-6591209963653-option-0-8" class="js-product-option ProductRadioButtons-itemRadio" type="radio" name="product-6591209963653-option-0" value="Sweet Apple" data-index="8" data-group-index="0"><label for="product-6591209963653-option-0-8" class="ProductRadioButtons-itemLabel Sweet Apple"><div sel-val="Sweet Apple" class="ProductRadioButtons-itemLabel-value Sweet Apple limitedScentLabel"></div></label><div class="ProductForm-variant-title Sweet Apple">Sweet Apple</div></div></div></div>';
   
   
   var variantFix = 0;
   

   //THIS INSERTS BEFORE
   if(insertScentBefore === true){
    parentBlock.insertBefore(newApple, childBlock);
    variantFix = 1; //This fixes the variants Indexes if Apple Spice is in Slot 1 (above) 
    document.getElementsByClassName('ProductRadioButtons-groupTitle')[1].innerHTML = "CLASSIC SCENTS"
   }
   

   //THIS INSERTS AFTER
  if (insertScentBefore === false) {
     Element.prototype.appendAfter = function (element) {
      element.parentNode.insertBefore(this, element.nextSibling);
     },false;
     newApple.appendAfter(childBlock)

     //moves scent profile above limited scents 
     if(document.getElementsByClassName('scentProfile')[0]){
       var scentProfileNode = document.getElementsByClassName('scentProfile')[0]
       scentProfileNode.appendAfter(childBlock)
       scentProfileNode.style.marginBottom = "20px"
    }

     document.getElementsByClassName('ProductRadioButtons-groupTitle')[0].innerHTML = "CLASSIC SCENTS"
  }

    //SIMULATE APPLE CLICK TO CHANGE BACKEND PRODUCT
    const limitedScents = document.getElementsByClassName('limitedScentItem');
    Array.from(limitedScents).forEach(limitedScent => {
      limitedScent.addEventListener('click', function(event) {
        var thisItem = event.target;
        console.log(thisItem);
        var findIndex = thisItem.dataset.index;
        console.log(findIndex);
        document.getElementsByClassName('ProductRadioButtons-item')[findIndex].click();
        document.getElementsByClassName('ProductRadioButtons-item')[findIndex].childNodes[0].click();
        document.getElementsByClassName('ProductRadioButtons-item')[findIndex].childNodes[1].click();
        document.getElementsByClassName('ProductRadioButtons-item')[findIndex].childNodes[2].click();
        document.getElementsByClassName('limitedScentLabel')[0].style.opacity = "1";
      });
    });

    // THIS UNCHECKS THE FAUX APPLE SPICE SELECTOR WHEN ANOTHER SCENT IS SELECTED
    const otherProductScents = document.getElementsByClassName('ProductRadioButtons-item');
    Array.from(otherProductScents).forEach(otherProductScent => {
      otherProductScent.addEventListener('click', function(event) {
          console.log(event.target)
          var limitedScentTempIndex = event.target.dataset.index;
          var limitedScentSKU = carpe_products['CP-UA'].variants[limitedScentTempIndex].sku;
          console.log(limitedScentSKU)
          if (limitedScentSKU != "CP-UA-SA") {
            document.getElementsByClassName('limitedScentLabel')[0].style.opacity = "0";
          }
        
      });
    });
   
   $('.ProductRadioButtons-itemLabel.Apple').css("margin-left","25px");
   $('.ProductForm-variant-title.Apple').css("text-align","left");
   $('.ProductForm-variant-title.Apple').css("margin-left","10px");
};
*/


//FRESH POWDER #1 SLOT TEST
$(document).ready(function() {
 if (freshPowderSlot === true) {
    var items = document.getElementsByClassName('ProductRadioButtons-item')[0];
    items.parentNode.insertBefore(document.getElementsByClassName('ProductRadioButtons-item')[5], items);
    document.getElementsByClassName('ProductRadioButtons-item')[0].firstElementChild.click();

   if ($(window).width() < 480) {
     var itemsLav = document.getElementsByClassName('ProductRadioButtons-item')[9];
     itemsLav.parentNode.insertBefore(document.getElementsByClassName('ProductRadioButtons-item')[2], itemsLav);
     var itemsFF = document.getElementsByClassName('ProductRadioButtons-item')[2];
     itemsFF.parentNode.insertBefore(document.getElementsByClassName('ProductRadioButtons-item')[9], itemsFF);
     document.getElementsByClassName('ProductRadioButtons-item')[2].style.display = "block";
   }
  }
});

  
  //this checks the child input when radio item is clicked - fixes issue of scent not changing when user clicks parent
$('.ProductRadioButtons-item').click(function() {
  var scentFixerIndex = $(this).index();
    //console.log(scentFixerIndex)
  if (scentFixerIndex != 8 && scentFixerIndex != 10 ) {
    document.getElementsByClassName('ProductRadioButtons-item')[scentFixerIndex].childNodes[1].click();
  }
});
  

  
//Pop-up stuff
  $('.js-additempopupclose').click(function(){
      $('#additem-popup').fadeOut('slow');
      var modal_overlay = document.querySelector('.modal_overlay');
      if (modal_overlay) {
        modal_overlay.classList.remove('active');
      }
  })
  $('.modal_overlay').click(function(){
      $('#progress-popup').fadeOut('slow');
      $('#additem-popup').fadeOut('slow');
      var modal_overlay = document.querySelector('.modal_overlay');
      if (modal_overlay) {
        modal_overlay.classList.remove('active');
      }
  })
 //Subscription block
 $('.rc_block rc_block__type rc_block__type__autodeliver').click(function() {
    var rc_block = document.querySelector('.rc_block rc_block__type rc_block__type__autodeliver');
    rc_block.classList.add('rc_block__type--active');
    $('.rc_block rc_block__type rc_block__type__onetime').removeClass('rc_block__type--active');

  })
 //TikTok Initiate checkout
 $('.Cart-checkoutButton').click(function() {
    ttq.track('InitiateCheckout');
  })     
});

//Subscription info modal JS
function subinfomodal() {
  document.getElementById('sub-info-modal').style.display = "block";
}
function closesubinfomodal() {
  document.getElementById('sub-info-modal').style.display = "none";
}
//Donate info modal JS
function donateinfomodal() {
  document.getElementById('donate-info-modal').style.display = "block";
}
function closedonateinfomodal() {
  document.getElementById('donate-info-modal').style.display = "none";
}


var jdgmImg = document.getElementsByClassName('jdgm-carousel-item__product-image');
for (var i=0; i<jdgmImg.length; i++) {
    if(jdgmImg[i].getAttribute('src')) {
       jdgmImg[i].classList.add('lazyload')
       jdgmImg[i].setAttribute('data-src',jdgmImg[i].getAttribute('src'));
       jdgmImg[i].removeAttribute('src');
       jdgmImg[i].removeAttribute('srcset');
    }
}


$('.menu-mobile').click(function() {
  $('.MenuMobile-item-placeholder').css("display","block");
});

$(document).ready(function() {
const el = document.querySelectorAll('.animate-on-scroll')
const headerObserver = new window.IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('animate')
      return
    }
  })
}, {
  root: null,
  threshold: 0, // set offset 0.1 means trigger if atleast 10% of element in viewport
})
for(i=0;i<el.length;i++){
  headerObserver.observe(el[i]);
} 
});

/* const el = document.querySelectorAll('.lazyloadBG')
const headerObserver = new window.IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.remove('lazyloadBG')
      entry.target.style.backgroundImage = 'url("'+entry.target.dataset.bgset+'")'
      return
    }
  })
  console.log('LEAVE');
}, {
  root: null,
  threshold: 0, // set offset 0.1 means trigger if atleast 10% of element in viewport
})
for(i=0;i<el.length;i++){
  headerObserver.observe(el[i]);
} */
$(document).ready(function() {
  if (atcAnimation === true) {
    document.querySelectorAll('.js-add-to-cart-submit').forEach(item => {
      item.addEventListener('click',function(){
        item.innerHTML = "Adding...";
        item.value = "Adding...";
        setTimeout(function(){
          item.classList.add('activeButton');
        },200)
      })
    });
  }
});
function removeAddedButton(){
  if(document.getElementsByClassName('activeButton')[0]) {
      document.getElementsByClassName('activeButton')[0].innerHTML = "Add To Cart";;
      document.getElementsByClassName('activeButton')[0].value = "Add To Cart";
      document.getElementsByClassName('activeButton')[0].classList.remove('activeButton');
  }
};

function clickOnCheckout(thisItem) {
  if (checkoutAnimation === true) {
      thisItem.innerHTML = "Checking Out...";
      thisItem.classList.add('activeButtonCheckout');
    }
}
//interval index for 6 week subs
$(document).ready(function() {
if (intervalIndex == 1) {
    document.getElementById('PDPrenew').innerHTML = "Renews every 6 weeks";
}
});

//switchs sub + save & scents
if (insertScentsBefore === true){
  var subWidget = document.getElementById('rc-custom-widget-container')
  subWidget.parentNode.insertBefore(document.getElementsByClassName('js-product-options')[0], subWidget)
  subWidget.parentNode.insertBefore(document.getElementById('frequencyLabel'), subWidget)
}

